import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import deedoftrust from "../images/deedoftrust.pdf";


function TrustDeed() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
          
            <div className="album py-1">
                <div className="container mt-2">
                    <p> CHUAPUKUR ISLAMIC CHARITABLE TRUST </p>
                </div>
            </div>
            <div className='charitabletrust'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Deed of Trust<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br />
            <div className='welcometext'>
                <div className="album py-0">
                    <div className="container">
                        <h1  style={{ color: "#1D4D93" }} className="card-title mb-0"><b>CHUAPUKUR ISLAMIC CHARITABLE TRUST : Deed of Trust</b></h1>
                        <div className="col-md-6">
                            <hr style={{ color: "#1D4D93" }} />
                        </div>
                        <br/>
                        <h6>Deed of Trust</h6>
                        <a href={deedoftrust} target="_blank" rel="noopener noreferrer">
                 <button className='islamictrustbutton'  >View / Download</button></a>
                    </div>
                </div>
            </div>

            <br />
        </div>
    )
}

export default TrustDeed